<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Kategorie auf unterster Ebene entfernen' }}</div>
  <dx-switch [(value)]="deleteLastCategory"></dx-switch>
</div>
